import { useContext, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchMetaOffersDiscount } from 'actions/MarketingAction'
import config from 'constants/config'
import { CookiesContext } from 'contexts/CookiesContext'

interface UseMetaOffersDiscountParams {
  offerId: string
  region: string
  checkIn: string
  checkOut: string
  occupancy: string
  enabled?: boolean
}

interface UseMetaOffersDiscountReturn {
  packages?: Array<{
    fkRoomTypeId: string
    rateId: string
    price: number
    salePrice: number
    discount: number
    discountPercentage: number
    name: string
  }>
  fetching: boolean
}

/**
 * Hook to fetch meta offers discount packages
 * Dispatches a Redux action to fetch discount data from the public-offer-feed API
 * Only fetches when metaofferSID cookie exists and all required params are provided
 */
export function useMetaOffersDiscount(params: UseMetaOffersDiscountParams): UseMetaOffersDiscountReturn {
  const { offerId, region, checkIn, checkOut, occupancy } = params
  const dispatch = useAppDispatch()
  const { getCookie } = useContext(CookiesContext)
  const metaofferSID = getCookie('metaofferSID')

  useEffect(() => {
    if (!!offerId && !!checkIn && !!checkOut && !!occupancy && config.ENABLE_META_OFFERS_DISCOUNT && metaofferSID) {
      dispatch(fetchMetaOffersDiscount({
        offerId,
        region,
        checkIn,
        checkOut,
        occupancy,
      }))
    }
  }, [offerId, region, checkIn, checkOut, occupancy, dispatch, metaofferSID])

  const packages = useAppSelector(state => state.marketing.metaOffersDiscount[offerId]?.packages)
  const fetching = useAppSelector(state => state.marketing.metaOffersDiscount[offerId]?.fetching ?? false)

  return { packages, fetching }
}
